import InputInline from "./InputInline";
import InputMultiline from "./InputMultiline";

const Input = (props) => {
  if (props.multiline) return <InputMultiline {...props} />;
  return <InputInline {...props} />;
};

export default Input;
